import { motion, useReducedMotion } from 'framer-motion';
import { variantMap, viewport } from '../../motion/variants';

const MotionReveal = ({
  children,
  className = '',
  delay = 0,
  variant = 'up',
  as: Tag = motion.div,
  ...props
}) => {
  const reduceMotion = useReducedMotion();

  return (
    <Tag
      initial={reduceMotion ? false : 'hidden'}
      whileInView={reduceMotion ? undefined : 'visible'}
      viewport={viewport}
      variants={variantMap[variant] || variantMap.up}
      transition={{ delay: reduceMotion ? 0 : delay / 1000, duration: reduceMotion ? 0 : undefined }}
      className={className}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default MotionReveal;